import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import { faCircleMinus } from '@fortawesome/free-solid-svg-icons';

export function CancelExecuteButton({ content, onClick, disabled }) {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={(
        <span className="fa-layers fa-fw fa-lg">
          <FontAwesomeIcon icon={faSave} />
          <FontAwesomeIcon icon={faCircleMinus} color="red" transform="shrink-4 down-4 right-4" />
        </span>
    )}
      onClick={onClick}
      disabled={disabled && false}
      title={content}
    >
      {content}
    </Button>
  );
}

CancelExecuteButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

CancelExecuteButton.defaultProps = {
  onClick: () => null,
  content: 'Відмінити проведення',
  disabled: false,
};

export default CancelExecuteButton;
